import { createContext, useState, useMemo } from "react";
import type { ScrollContextType } from "./ScrollContext.d";

export const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export function ScrollProvider({ children }: { children: React.ReactNode }) {
  const [isAnchorInView, setAnchorInView] = useState(false);

  const value = useMemo(
    () => ({
      isAnchorInView,
      setAnchorInView,
    }),
    [isAnchorInView, setAnchorInView]
  );

  return <ScrollContext.Provider value={value}>{children}</ScrollContext.Provider>;
}
